document.addEventListener('DOMContentLoaded', function() {
  const slideInItems = document.querySelectorAll('.slide-up-animated');
  if (!slideInItems) return;
    slideInItems.forEach((item)=>{
    item.classList.add('animation-start');
  });
})
function getSliderSettings() {
  return {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };
}
function getSubSliderProductSettings() {
  return {
    slidesPerView: "auto",
    direction: "vertical",
    navigation: false,
  };
}

const sliderInit = (isUpdate) => {
  if(document.querySelectorAll(".product-section .js-media-list") && document.querySelectorAll(".product-section .js-media-list").length > 0){
    let slider = new Swiper(".product-section .js-media-list", {
      keyboard: false,
      slidesPerView: 1,
      //autoHeight: true,
      navigation: {
        nextEl: ".swiper-btn--next",
        prevEl: ".swiper-btn--prev",
      },
      pagination: {
        el: `.slider-pagiantion-bullet .swiper-pagination`,
        clickable: "true",
        type: "bullets",
        renderBullet: function (activeIndex, className) {
          return (
            '<span class="' + className + '">' + "<em>" + activeIndex + "</em>" + "<i></i>" + "<b></b>" + "</span>"
          );
        },
      },
      thumbs: {
        swiper: document.querySelector(".product-section .js-media-sublist").swiper,
      },
      on: {
        slideChangeTransitionStart: function () {
          document.querySelector(".product-section .js-media-sublist").swiper.slideTo(document.querySelector(".product-section .js-media-list").swiper.activeIndex,);
        },
        slideChange: function () {
          window.pauseAllMedia();
          this.params.noSwiping = false;
        },
        slideChangeTransitionEnd: function () {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            this.slides[this.activeIndex].querySelector(".shopify-model-viewer-ui__button--poster").removeAttribute("hidden");
          }
        },
        touchStart: function (s, e) {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            if(!this.slides[this.activeIndex].querySelector("model-viewer").classList.contains("shopify-model-viewer-ui__disabled")){
              this.params.noSwiping = true;
              this.params.noSwipingClass = "swiper-slide";
            }
          }
        },
      },
    });
    if (isUpdate) {
      setTimeout(function () { slider.update(); }, 800);
    }
  }
};

const subSliderInit = (isUpdate) => {
  if (document.querySelectorAll(".product-section .js-media-sublist") && document.querySelectorAll(".product-section .js-media-sublist").length > 0){
    let subSlider = new Swiper(".product-section .js-media-sublist", {
      keyboard: false,
      centeredSlides: true,
      centeredSlidesBounds: true,
      slidesPerView: 3,
      spaceBetween: 24,
      direction: "horizontal",
      navigation: false,
      freeMode: false,
      watchSlidesProgress: true,
      on: {
        touchEnd: function (s, e) {
          let range = 5;
          let diff = (s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY);
          if (diff < range || diff > -range) s.allowClick = true;
        },
      },
      transitionStart: function () {
        document.querySelector(".product-section .js-media-list").swiper.slideTo(document.querySelector(".product-section.js-media-sublist").swiper.activeIndex,);
      },
      breakpoints: {
        1200: {
          direction: "vertical",
          slidesPerView: "auto",
          centeredSlides: false,
          allowTouchMove: false,
        },
      },
    });
    if (isUpdate) {
      setTimeout(function () {
        subSlider.update();
      }, 800);
    }
  }
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
    return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey){
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}',"*",);
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
  
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  
    var eventList = ["paste", "input"];
    for (event of eventList) {
      this.input.addEventListener(event, function (e) {
        const numberRegex = /^0*?[1-9]\d*$/;
  
        if ( numberRegex.test(e.currentTarget.value) || e.currentTarget.value === "" ) {
          e.currentTarget.value;
        } else {
          e.currentTarget.value = 1;
        }
      });
    }
  
    this.input.addEventListener("focusout", function (e) {
      if (e.currentTarget.value === "") {
        e.currentTarget.value = 1;
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
      options["hideElement"] || province_domid,
	);

	Shopify.addListener(
      this.countryEl,
      "change",
      Shopify.bind(this.countryHandler, this),
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) => {
      if (this.querySelector(".header__localization-button") === button) return;
      if (this.querySelector(".header__localization-lang-button") === button) return;
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`,
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
        this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

	connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
	}

	show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector(".template-popup");
      document.body.classList.add("overflow-hidden");
      this.setAttribute("open", "");
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
	}

	hide() {
      let isOpen = false;

      this.removeAttribute("open");
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();

      document.querySelectorAll("body > quick-add-modal").forEach((el) => {
        if (el.hasAttribute("open")) {
          isOpen = true;
        }
      });

      if (!isOpen) {
        document.body.classList.remove("overflow-hidden");
        document.body.dispatchEvent(new CustomEvent("modalClosed"));
      }
	}
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this),
    );
    if (this.getAttribute("data-autoplay")) {
      this.loadContent();
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );
      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.getAttribute("data-autoplay")) {
                let playPromise = entry.target.play();
                if (playPromise !== undefined) {
                  playPromise.then(_ => {}).catch(error => {});
                }
              }
            }
            else {
              entry.target.pause()
            }
          })
        }
      )
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );      
      
      if (
        deferredElement.nodeName == "VIDEO" ||
        deferredElement.nodeName == "IFRAME"
      ) {
        // force autoplay for safari
        
        if (this.classList.contains('video-section__media')) {
          let playPromise = deferredElement.play();
          if (playPromise !== undefined) {
            playPromise.then(_ => {}).catch(error => {});
          }
          videoObserver.observe(deferredElement);
        }
        else {
          deferredElement.play();
        }
      }
      if (
        this.closest(".swiper")?.swiper.slides[
          this.closest(".swiper").swiper.activeIndex
        ].querySelector("model-viewer")
      ) {
        if (
          !this.closest(".swiper")
            .swiper.slides[
              this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
            .classList.contains("shopify-model-viewer-ui__disabled")
        ) {
          this.closest(".swiper").swiper.params.noSwiping = true;
          this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".slider");
    this.sliderItems = this.querySelectorAll(".slider__slide");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth,
    );
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMediaSub();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    ).concat(
      fieldsets.map((fieldset) => {

        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked,
        ).value;
      })
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector('[type="application/json"]')) {
      this.currentVariant = this.getVariantData().find((variant) => {
        this.options.sort();
        variant.options.sort();

        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });

    if (document.querySelector(".js-media-list")) {
      sliderInit();
    }
  }

  updateMediaSub() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const newMediaSub = document.querySelector(
      `[data-media-sub-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
    );

    if (
      document.querySelector(".js-media-sublist") &&
      document.querySelector(".js-media-sublist").swiper != null
    ) {
      document.querySelector(".js-media-sublist").swiper.destroy();
    }

    if (!newMediaSub) return;
    const parentSub = newMediaSub.parentElement;
    parentSub.prepend(newMediaSub);
    window.setTimeout(() => {
      parentSub.scroll(0, 0);
    });

    if (document.querySelector(".js-media-sublist")) {
      subSliderInit();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === 'OPTION') {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === 'INPUT') {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === 'OPTION') {
          input.innerText = window.variantStrings.unavailable_with_option.replace(
            "[value]",
            input.getAttribute("value"),
          );
        } else if (input.tagName === 'INPUT') {
          input.classList.add("disabled");
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
    .then((response) => response.text())
    .then((responseText) => {
      // prevent unnecessary ui changes from abandoned selections
      if (this.currentVariant.id !== requestedVariantId) return;

      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.getElementById(
        `price-${this.dataset.section}`,
      );
      const source = html.getElementById(
        `price-${
          this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
        }`,
      );
      const skuSource = html.getElementById(
        `Sku-${
          this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
        }`,
      );
      const skuDestination = document.getElementById(
        `Sku-${this.dataset.section}`,
      );
      const inventorySource = html.getElementById(
        `Inventory-${
          this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
        }`,
      );
      const inventoryDestination = document.getElementById(
        `Inventory-${this.dataset.section}`,
      );

      if (source && destination) destination.innerHTML = source.innerHTML;
      if (inventorySource && inventoryDestination)
        inventoryDestination.innerHTML = inventorySource.innerHTML;
      if (skuSource && skuDestination) {
        skuDestination.innerHTML = skuSource.innerHTML;
        skuDestination.classList.toggle(
          "visibility-hidden",
          skuSource.classList.contains("visibility-hidden"),
        );
      }

      const price = document.getElementById(`price-${this.dataset.section}`);

      if (price) price.classList.remove("visibility-hidden");

      if (inventoryDestination)
        inventoryDestination.classList.toggle(
          "visibility-hidden",
          inventorySource.innerText === "",
        );

      const addButtonUpdated = html.getElementById(
        `ProductSubmitButton-${sectionId}`,
      );
      this.toggleAddButton(
        addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
        window.variantStrings.soldOut,
      );
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelectorAll('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");

      if (text) {
        addButtonText.forEach((elem) => {
          elem.innerHTML = `${text}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
</svg>`;
        });
      }
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.forEach((elem) => {
        elem.innerHTML = `${window.variantStrings.addToCart}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
</svg>`;
      });
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelectorAll('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.forEach((elem) => {
      elem.innerHTML = `${window.variantStrings.unavailable}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
</svg>`;
    });
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductModel extends DeferredMedia {
  constructor() {
    super();
  }

  loadContent() {
    super.loadContent();

    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(
      this.querySelector("model-viewer"),
    );

    const $this = this;

    this.querySelector(".shopify-model-viewer-ui__button").addEventListener(
      "click",
      function () {
        if (
          $this
            .closest(".swiper")
            .swiper.slides[
              $this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
        ) {
          if (
            !$this
              .closest(".swiper")
              .swiper.slides[
                $this.closest(".swiper").swiper.activeIndex
              ].querySelector("model-viewer")
              .classList.contains("shopify-model-viewer-ui__disabled")
          ) {
            if (
              $this
                .querySelector(".shopify-model-viewer-ui__button")
                .hasAttribute("hidden")
            ) {
              $this.closest(".swiper").swiper.params.noSwiping = true;
              $this.closest(".swiper").swiper.params.noSwipingClass =
                  "swiper-slide";
            }
          }
        }
      },
    );

      this.querySelector(
        ".shopify-model-viewer-ui__controls-overlay",
      ).addEventListener("click", function () {
        if (
          !$this
            .querySelector(".shopify-model-viewer-ui__button")
            .hasAttribute("hidden")
        ) {
          $this.closest(".swiper").swiper.params.noSwiping = false;
        }
      });
	}
}
customElements.define("product-model", ProductModel);

// Product slider

(function () {
  const productSlider = () => {
    const productSliders = Array.from(document.querySelectorAll('.products-slider'));
    if (productSliders.length === 0) return;
    productSliders.forEach(slider => {
      const sectionId = slider.dataset.id;
      const perRow = slider.dataset.perRow;
      const speed = slider.dataset.speed * 1000;
      const delay = slider.dataset.delay * 1000;
      const autoplay = toBoolean(slider.dataset.autoplay);
      const stopAutoplay = toBoolean(slider.dataset.stopAutoplay);
      const showArrows = toBoolean(slider.dataset.showArrows);
      let autoplayParm = {};
      let arrowsParm = {};
      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      }
      if(showArrows) {
        arrowsParm = {
          navigation: {
            nextEl: `#${sectionId} .swiper-button-next`,
            prevEl: `#${sectionId} .swiper-button-prev`,
          },
          pagination: {
            el: `#${sectionId} .swiper-pagination`,
            clickable: true,
          },
        }
      }
      let swiperParms = {
        speed : speed,
        keyboard: false,
        slidesPerView : "auto",
        spaceBetween : 16,
        breakpoints: {
          576: {
            slidesPerView: 'auto',
          },
          1200: {
            spaceBetween : 24,
            slidesPerView: 'auto',
          },
        },
        ...arrowsParm,
        ...autoplayParm,
      }
  
      const swiper = new Swiper(`#${sectionId} .swiper`, swiperParms);
      if(window.innerWidth < 1200) return;
      const image = document.querySelectorAll(`#${sectionId} .swiper .product-card .media img`)[0];
      if(image){
        const height = image.offsetHeight;
        document.querySelectorAll(`#${sectionId} .swiper-button`).forEach((button) => {
          button.style.top = height / 2 + 'px';
        });
      }
    })
  }
  const productpatternSlider = () => {
    const productpatternSliders = Array.from(document.querySelectorAll('.pattern-products-slider'));
    if (productpatternSliders.length === 0) return;
    productpatternSliders.forEach(slider => {
      const sectionId = slider.dataset.id;
      // const perRow = slider.dataset.perRow;
      const speed = slider.dataset.speed * 1000;
      const delay = slider.dataset.delay * 1000;
      const autoplay = toBoolean(slider.dataset.autoplay);
      const stopAutoplay = toBoolean(slider.dataset.stopAutoplay);
      const showArrows = toBoolean(slider.dataset.showArrows);
      let autoplayParm = {};
      let arrowsParm = {};
      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      }
      if(showArrows) {
        arrowsParm = {
          navigation: {
            nextEl: `#${sectionId} .swiper-button-next`,
            prevEl: `#${sectionId} .swiper-button-prev`,
          },
          pagination: {
            el: `#${sectionId} .swiper-pagination`,
            clickable: true,
          },
        }
      }
      let swiperParms = {
        speed : speed,
        keyboard: false,
        slidesPerView : "auto",
        spaceBetween : 16,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        breakpoints: {
          576: {
            slidesPerView: 'auto',
          },
          1200: {
            spaceBetween : 24,
            slidesPerView: 'auto',
          },
        },
        ...arrowsParm,
        ...autoplayParm,
      }

      const swiper = new Swiper(`#${sectionId} .swiper`, swiperParms);

      const filters = document.querySelectorAll(".list-tag-wrapp .list-tag-label");
      function updateFilter(activeFilter) {
        const filters = document.querySelectorAll(".list-tag-wrapp .list-tag-label");
        if (!activeFilter) {
          filters[0].classList.add("active");
          activeFilter = filters[0];
        }
        const filter = activeFilter.innerText.toLowerCase();
        Array.prototype.forEach.call(filters, function (el) {
          if (el === activeFilter) {
            el.classList.add("active");
          } else {
            el.classList.remove("active");
          }
        });
      }

      const swiperParms2 = {
          speed : speed,
          keyboard: false,
          slidesPerView : "auto",
          spaceBetween : 16,
          breakpoints: {
            576: {
              slidesPerView: 'auto',
            },
            1200: {
              spaceBetween : 24,
              slidesPerView: 'auto',
            },
          },
          pagination: {
              el: '.swiper-pagination',
              clickable: true,
          },
      };

      Array.prototype.forEach.call(filters, function (_filter) {
        _filter.addEventListener("click", function (e) {
        const self = this;
        const filter = self.getAttribute("data-filter");
        updateFilter(self);
        console.log("filter:", filter);
          if (filter == "all") {
            Array.prototype.forEach.call(
              document.querySelectorAll(".products-slider__swiper [data-filter]"),
              function (_item) {
                _item.classList.remove("non-swiper-slide");
                _item.classList.add("swiper-slide");
              }
            );
            swiper.destroy();
            let swiperReset = new Swiper(".products-slider__swiper", swiperParms);
          } else {
            Array.prototype.forEach.call(
              document.querySelectorAll(
                ".products-slider__swiper [data-filter]"
              ),
              (el) => {
                el.classList.add("non-swiper-slide");
                el.classList.remove("swiper-slide");
                el.removeAttribute("style");
              }
            );
            Array.prototype.forEach.call(
              document.querySelectorAll(
                ".products-slider__swiper [data-filter='" + filter + "']"
              ),
              (el) => {
                el.classList.remove("non-swiper-slide");
                el.classList.add("swiper-slide");
                el.removeAttribute("style");
              }
            );
            swiper.destroy();
            let swiperReset1 = new Swiper(".products-slider__swiper", swiperParms);
          }
        });
      });
      updateFilter(null);
    })
  }

  function toBoolean(string) {
    return string === 'true' ? true : false
  }
  if(document.querySelector('product-recommendations') !== null ) {
    const initslider = setInterval(() => {
      if (document.querySelector('product-recommendations').querySelector('.swiper') !== null) {
        if (document.querySelector('product-recommendations').querySelector('.swiper').classList.contains('swiper-initialized')) {clearInterval(initslider);}
        productSlider();
        productpatternSlider();
      }
    }, 100);
  }
  if(document.querySelector('product-complementary') !== null ) {
    const initslider = setInterval(() => {
      if (document.querySelector('product-complementary').querySelector('.swiper') !== null) {
        if (document.querySelector('product-complementary').querySelector('.swiper').classList.contains('swiper-initialized')) {clearInterval(initslider);}
        productSlider();
        productpatternSlider();
      }
    }, 100);
  }
  document.addEventListener("DOMContentLoaded", function () {
    productSlider();
    productpatternSlider();
    document.addEventListener("shopify:section:load", function () {
      productSlider();
      productpatternSlider();
    });
  });
})();

var init = false;
var Brandswiper;
function initbrandSwiper() {
  if (window.innerWidth > 1199) {
    if (!init) {
      init = true;
      Brandswiper = new Swiper(".brandicon__swiper", {
        keyboard: false,
        slidesPerView: 9,
        spaceBetween: 24,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  } else if (init) {
    Brandswiper.destroy();
    init = false;
  }
}


document.addEventListener('DOMContentLoaded', function() {
  initbrandSwiper();
});
document.addEventListener('DOMContentLoaded', function() {

  var callswiper2 = new Swiper ('.callout-slider-textcontent', {
    keyboard: false,
    spaceBetween: 20,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
          el: `.slider-pagiantion-bullet .swiper-pagination`,
          clickable: "true",
          type: "bullets",
          renderBullet: function (activeIndex, className) {
              return (
                  '<span class="' +
                  className +
                  '">' +
                  "<em>" +
                  activeIndex +
                  "</em>" +
                  "<i></i>" +
                  "<b></b>" +
                  "</span>"
              );
          }
      },
    breakpoints: {
      768: {
        spaceBetween: 10
      }
    }
  });
  
  var callswiper = new Swiper ('.callout-slider-images', {
      keyboard: false,
      slidesPerView: 'auto',
      spaceBetween: 10,
      slideToClickedSlide: true,
  });
  
  callswiper2.controller.control = callswiper;
  callswiper.controller.control = callswiper2;
});
window.addEventListener("resize", initbrandSwiper);

/*
document.querySelectorAll('.list-tag-label').forEach(function (event) {
    event.addEventListener("click", function name(e) {
        var Dataval = e.target.dataset.filter;
        e.target.closest(".popular-products").querySelector('.products-slider__swiper')
        debugger;
    })
})
*/
function videoreviewSwiper() {
  var videoReview = new Swiper(".product-video-review-wrapper", {
    keyboard: false,
    slidesPerView: 1,
    draggable: true,
    navigation: {
      nextEl: ".product-about__accordion-description .swiper-button-next",
      prevEl: ".product-about__accordion-description .swiper-button-prev",
    },
    pagination: {
        el: `.product-about__accordion-description .swiper-pagination`,
        clickable: "true",
        type: "bullets",
        renderBullet: function (activeIndex, className) {
            return (
                '<span class="' +
                className +
                '">' +
                "<em>" +
                activeIndex +
                "</em>" +
                "<i></i>" +
                "<b></b>" +
                "</span>"
            );
        }
    },
  });
}

function PatternsyarnSwiper() {
  var PatternsyarnReview = new Swiper(".compatible-slider__swiper", {
    keyboard: false,
    slidesPerView: 'auto',
    draggable: true,
    spaceBetween: 19
  });
}

const $fbt_money_format = function(t,r){function e(t,r){return void 0===t?r:t}function a(t,r,a,o){if(r=e(r,2),a=e(a,","),o=e(o,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(r);let n=t.split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+a)+(n[1]?o+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));let o="",n=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(n)[1]){case"amount":o=a(t,2);break;case"amount_no_decimals":o=a(t,0);break;case"amount_with_comma_separator":o=a(t,2,".",",");break;case"amount_with_space_separator":o=a(t,2," ",",");break;case"amount_with_period_and_space_separator":o=a(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=a(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=a(t,0,".","");break;case"amount_with_space_separator":o=a(t,2,",","");break;case"amount_with_apostrophe_separator":o=a(t,2,"'",".")}return i.replace(n,o)};
if (document.querySelector('.prod_total_price')){
  const $fbt_currency = document.querySelector('.prod_total_price').getAttribute('data-currency');
  document.querySelector(".qty_main_product").addEventListener("change",function(e) {
     var ProductPrice = document.querySelector(".prod_total_price").dataset.totalprice;
     var ProductComparePrice = document.querySelector(".prod_total_price").dataset.comparePrice;
     var ProductQty =  this.value;
     var ProductFinalPrice =  ProductPrice * ProductQty;
     var ProductFinalComparePrice =  ProductComparePrice * ProductQty;
     console.log("Product Qty",this.value,"Product Price",ProductPrice,"Product Final Price",ProductFinalPrice,"Product Compare Price",ProductComparePrice,"ProductFinalComparePrice",ProductFinalComparePrice);
    if(ProductFinalComparePrice && ProductFinalComparePrice) {
      document.querySelector(".prod_total_price").querySelector(".price__sale").querySelector(".price-item--sale").innerHTML = $fbt_money_format(ProductFinalPrice, $fbt_currency);
      document.querySelector(".prod_total_price").querySelector(".price__sale").querySelector(".price-item--regular").innerHTML = $fbt_money_format(ProductFinalComparePrice, $fbt_currency);
    } else {
      document.querySelector(".prod_total_price").querySelector(".price-item--regular").innerHTML = $fbt_money_format(ProductFinalPrice, $fbt_currency);
    }
  });
}
if (document.querySelector('.meta_info_alllink')){
  document.querySelector('.meta_info_alllink').addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    this.closest('.meta_info_lists').classList.toggle("moredetailshow");
    if(this.closest('.meta_info_lists').classList.contains('moredetailshow')){
      this.closest('.meta_info_lists').querySelectorAll('.view_more_list').forEach(function (e) {
        e.style.display = "flex";
      });
    }else{
      this.closest('.meta_info_lists').querySelectorAll('.view_more_list').forEach(function (e) {
        e.style.display = "none";
      });
    }
  });
}

/* COLLECTIONS RANDER PRODUCT PAGE */

const loadItemscoll = (button) => {
  const totalPagescoll = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage+1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();
    },
    complete: function() {
      if (currentPage <= totalPagescoll) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPagescoll) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
          scollData.querySelector('input[data-current-page]').value =  currentPage;
          checkVisibilitycoll();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPagescoll) {
          button.remove();
        }
      } 
    }
  })
}

const checkVisibilitycoll = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItemscoll(spinner);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMoreColl() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItemscoll(button);
    }
  });
  checkVisibilitycoll();
}

var collURL = (document.querySelector('#product-collection-wrapper')?.getAttribute('data-url')) ? document.querySelector('#product-collection-wrapper').getAttribute('data-url') : 'https://jimmybeanswool.myshopify.com/collections/yarn?view=yarn-products';
var collectionUrl = collURL;
var SelectName = "";
var SelectValue = "";

function fetchCollectionContent(collurl) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', collurl, true);
  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      var parser = new DOMParser();
      var htmlDoc = parser.parseFromString(xhr.responseText, 'text/html');
      var extractedContent = htmlDoc.querySelector('.collection-grid-section').innerHTML
      document.getElementById('product-collection-wrapper').innerHTML = extractedContent;
      loadMoreColl();

      if(document.querySelector('.custom_filter_sort_wrapp')){
        if(document.querySelector('.custom_filter_sort_wrapp .facets__list')){
          document.querySelector('.custom_filter_sort_wrapp .facets__list').querySelectorAll('.list-menu__item').forEach(function (list) {
            list.querySelector('input').addEventListener('change', (opt) => {
              var SelectName = opt.target.getAttribute("name");
              var SelectValue = opt.target.value;
              var filerColor = "&"+SelectName+"="+SelectValue;
              var SortSelect = document.querySelector('.custom_filter_sort_wrapp .facets-sorting__field .select__select').value;
              var collectionUrl = collURL+'&sort_by='+SortSelect+filerColor;
              fetchCollectionContent(collectionUrl);
            });
          });
        }
        if (document.querySelector('.custom_filter_sort_wrapp .facets-sorting__field .select__select')) {
          document.querySelector('.custom_filter_sort_wrapp .facets-sorting__field .select__select').addEventListener("change",function (select) {
            if(document.querySelector('.custom_filter_sort_wrapp .facets__list--color input:checked')){
              var SelectName = document.querySelector('.custom_filter_sort_wrapp .facets__list--color input:checked').getAttribute("name");
              var SelectValue = document.querySelector('.custom_filter_sort_wrapp .facets__list--color input:checked').value;
              var filerColor = "&"+SelectName+"="+SelectValue;
              var SortSelect = this.value;
              var collectionUrl = collURL+'&sort_by='+SortSelect+filerColor;
              fetchCollectionContent(collectionUrl);
            }else{
              var SortSelect = this.value;
              var collectionUrl = collURL+'&sort_by='+SortSelect;
              fetchCollectionContent(collectionUrl);
            }
          });
        }
        if(document.querySelector('.custom_filter_sort_wrapp .facets__list--color input:checked')){
          document.querySelector('.list-menu__itemclear.list-menu__clearitem').classList.remove("hide");
        }
        if (document.querySelector('.list-menu__itemclear.list-menu__clearitem .list-menu__clearinn')) {
          document.querySelector('.list-menu__itemclear.list-menu__clearitem .list-menu__clearinn').addEventListener("click",function (event) {
            event.preventDefault();
            event.stopPropagation();
            var collectionUrl = event.target.dataset.value;
            fetchCollectionContent(collectionUrl);
          });
        }
      }
      if(document.querySelector('.mobile_facets_filter_wrapp')){
        document.querySelector('.custmobile-facets__main').querySelectorAll('.mobile-facets__item--color').forEach(function (icolor) {
          icolor.querySelector('input').addEventListener("change", function (ce) {
            document.querySelector('.custmobile-facets__main').querySelectorAll('.mobile-facets__item--color').forEach(function (icolor) {
              icolor.querySelector('input').checked = false;
            });
            ce.target.checked = true;
          });
        });
        document.querySelectorAll('.mobile-facets__footer .custmobile-facets__clear').forEach(function (event) {
            event.addEventListener("click",function (e) {
              e.preventDefault();
              e.stopPropagation();
              var collectionUrl = this.dataset.value;
              fetchCollectionContent(collectionUrl);
            });
        });
        document.querySelectorAll('.mobile-facets__footer .custmobile-facets__submit').forEach(function (event) {
          event.addEventListener("click",function (e) {
            e.preventDefault();
            e.stopPropagation();
            if(document.querySelector('.custmobile-facets__main .mobile-facets__item--color input:checked')){
              var SelectName = document.querySelector('.custmobile-facets__main .mobile-facets__item--color input:checked').getAttribute("name");
              var SelectValue = document.querySelector('.custmobile-facets__main .mobile-facets__item--color input:checked').value;
              var filerColor = "&"+SelectName+"="+SelectValue;
              var SortSelect = document.querySelector('.custfacet_mobile-facets__sort .select__select').value;
              var collectionUrl = collURL+'&sort_by='+SortSelect+filerColor;
              console.log("collectionUrl:-",collectionUrl);
              fetchCollectionContent(collectionUrl);
            }else{
              var SortSelect = document.querySelector('.custfacet_mobile-facets__sort .select__select').value;
              var collectionUrl = collURL+'&sort_by='+SortSelect;
              console.log("collectionUrl:-",collectionUrl);
              fetchCollectionContent(collectionUrl);
            }
          });
        });
      }
    } else {
      console.error('Error fetching collection content:', xhr.statusText);
    }
  };
  xhr.onerror = function () {
    console.error('Error fetching collection content:', xhr.statusText);
  };
  xhr.send();
}

document.addEventListener('DOMContentLoaded', function() {
  PatternsyarnSwiper();
  videoreviewSwiper();
  if(document.getElementById('product-collection-wrapper')){
   fetchCollectionContent(collectionUrl);
  }
});
if (document.querySelectorAll(".product-swatches-shades-colors a")) {
  document.querySelectorAll(".product-swatches-shades-colors a").forEach((link) => {
   link.addEventListener("click", function(event) {
    event.preventDefault();
    event.stopPropagation();
    var secondElement = document.querySelector("#product-collection-wrapper");
    if (secondElement) {
     secondElement.scrollIntoView({
      behavior: "smooth"
     });
    }
   });
  });
}

document.addEventListener("DOMContentLoaded", function () {
 var swiper = new Swiper(".image-text-slider-main", {
 keyboard: false,
  slidesPerView: 'auto',
  spaceBetween: 16,
  centeredSlides: false,
  navigation: {
   nextEl: ".image-text-slider-wrapper .swiper-button-next",
   prevEl: ".image-text-slider-wrapper .swiper-button-prev",
  },
  breakpoints: {
   768: {
    spaceBetween: 24,
    slidesPerView: 'auto',
   },
  },
 });
});


function InspirTab() {
  let para = document.querySelector('.product-opt-inspir-desk');
  if(para.classList.contains("show")){
    para.classList.remove("show");
  }else{
    para.classList.add("show");
  }
}


document.addEventListener("DOMContentLoaded", function() {
  var questionMarkPopups = document.querySelectorAll('.question-mark-popup');

  questionMarkPopups.forEach(function(questionMarkPopup) {
    questionMarkPopup.addEventListener('click', function() {
      document.body.classList.add('open-popup');
      var richTextParagraphs = document.querySelectorAll('.metafield-rich_text_field p');
    
      richTextParagraphs.forEach(function(paragraph) {
        // Remove existing close buttons
        var existingCloseBtn = paragraph.querySelector('.close-btn');
        if (existingCloseBtn) {
          existingCloseBtn.remove();
        }
      
        // Add close button
        paragraph.innerHTML += '<button class="close-btn"></button>';
        paragraph.style.display = "block";
      
        // Delegate the click event handling to a static parent element
        document.addEventListener('click', function(event) {
          event.preventDefault();
          if (event.target.classList.contains('close-btn')) {
            document.body.classList.remove('open-popup');
            var richTextParagraphs = document.querySelectorAll('.metafield-rich_text_field p');
            richTextParagraphs.forEach(function(paragraph) {
              paragraph.style.display = "none";
            });
          }
        });
      });
    });
  });
});

if(document.querySelector('#crochet_knitting_calculator_form')){
  const $finish_sizes = [
    {'project_type':'baby_and_kids_cardigans', 'finish_type_val':'20-chest-size-6-months', 'finish_type_inch':'20" chest size (6 months)', 'finish_type_cm':'50.5 cm chest size (6 months)', 'total_len_in_meters_at_min_sts':'153'},
    {'project_type':'baby_and_kids_cardigans', 'finish_type_val':'22-chest-size-12-months', 'finish_type_inch':'22" chest size (12 months)', 'finish_type_cm':'56 cm chest size (12 months)', 'total_len_in_meters_at_min_sts':'175'},
    {'project_type':'baby_and_kids_cardigans', 'finish_type_val':'24-chest-size-18-months', 'finish_type_inch':'24" chest size (18 months)', 'finish_type_cm':'61 cm chest size (18 months)', 'total_len_in_meters_at_min_sts':'185'},
    {'project_type':'baby_and_kids_cardigans', 'finish_type_val':'25-chest-size-2', 'finish_type_inch':'25" chest size (2)', 'finish_type_cm':'63.5 cm chest size (2)', 'total_len_in_meters_at_min_sts':'196'},
    {'project_type':'baby_and_kids_cardigans', 'finish_type_val':'27-chest-size-4', 'finish_type_inch':'27" chest size (4)', 'finish_type_cm':'68.5 cm chest size (4)', 'total_len_in_meters_at_min_sts':'229'},
    {'project_type':'baby_and_kids_cardigans', 'finish_type_val':'29-chest-size-6', 'finish_type_inch':'29" chest size (6)', 'finish_type_cm':'73.5 cm chest size (6)', 'total_len_in_meters_at_min_sts':'273'},
    {'project_type':'baby_and_kids_cardigans', 'finish_type_val':'31-chest-size-8', 'finish_type_inch':'31" chest size (8)', 'finish_type_cm':'78.5 cm chest size (8)', 'total_len_in_meters_at_min_sts':'316'},
    {'project_type':'baby_and_kids_cardigans', 'finish_type_val':'33-chest-size-10', 'finish_type_inch':'33" chest size (10)', 'finish_type_cm':'84 cm chest size (10)', 'total_len_in_meters_at_min_sts':'375'},
    {'project_type':'baby_and_kids_cardigans', 'finish_type_val':'35-chest-size-12', 'finish_type_inch':'35" chest size (12)', 'finish_type_cm':'89 cm chest size (12)', 'total_len_in_meters_at_min_sts':'415'},
    {'project_type':'baby_and_kids_pullovers', 'finish_type_val':'20-chest-size-6-months', 'finish_type_inch':'20" chest size (6 months)', 'finish_type_cm':'50.5 cm chest size (6 months)', 'total_len_in_meters_at_min_sts':'145'},
    {'project_type':'baby_and_kids_pullovers', 'finish_type_val':'22-chest-size-12-months', 'finish_type_inch':'22" chest size (12 months)', 'finish_type_cm':'56 cm chest size (12 months)', 'total_len_in_meters_at_min_sts':'166'},
    {'project_type':'baby_and_kids_pullovers', 'finish_type_val':'24-chest-size-18-months', 'finish_type_inch':'24" chest size (18 months)', 'finish_type_cm':'61 cm chest size (18 months)', 'total_len_in_meters_at_min_sts':'177'},
    {'project_type':'baby_and_kids_pullovers', 'finish_type_val':'25-chest-size-2', 'finish_type_inch':'25" chest size (2)', 'finish_type_cm':'63.5 cm chest size (2)', 'total_len_in_meters_at_min_sts':'187'},
    {'project_type':'baby_and_kids_pullovers', 'finish_type_val':'27-chest-size-4', 'finish_type_inch':'27" chest size (4)', 'finish_type_cm':'68.5 cm chest size (4)', 'total_len_in_meters_at_min_sts':'218'},
    {'project_type':'baby_and_kids_pullovers', 'finish_type_val':'29-chest-size-6', 'finish_type_inch':'29" chest size (6)', 'finish_type_cm':'73.5 cm chest size (6)', 'total_len_in_meters_at_min_sts':'260'},
    {'project_type':'baby_and_kids_pullovers', 'finish_type_val':'31-chest-size-8', 'finish_type_inch':'31" chest size (8)', 'finish_type_cm':'78.5 cm chest size (8)', 'total_len_in_meters_at_min_sts':'301'},
    {'project_type':'baby_and_kids_pullovers', 'finish_type_val':'33-chest-size-10', 'finish_type_inch':'33" chest size (10)', 'finish_type_cm':'84 cm chest size (10)', 'total_len_in_meters_at_min_sts':'357'},
    {'project_type':'baby_and_kids_pullovers', 'finish_type_val':'35-chest-size-12', 'finish_type_inch':'35" chest size (12)', 'finish_type_cm':'89 cm chest size (12)', 'total_len_in_meters_at_min_sts':'395'},
    {'project_type':'baby_and_kids_socks', 'finish_type_val':'3-5-4-5-size-baby-1-4', 'finish_type_inch':'3.5 - 4.5" size (Baby 1 - 4)', 'finish_type_cm':'9 - 11.5 cm size (Baby 1 - 4)', 'total_len_in_meters_at_min_sts':'44'},
    {'project_type':'baby_and_kids_socks', 'finish_type_val':'4-5-6-size-toddler-5-9', 'finish_type_inch':'4.5 - 6" size (Toddler 5 - 9)', 'finish_type_cm':'11.5 - 15 cm size (Toddler 5 - 9)', 'total_len_in_meters_at_min_sts':'60'},
    {'project_type':'baby_and_kids_socks', 'finish_type_val':'6-5-7-5-size-toddler-10-13', 'finish_type_inch':'6.5 - 7.5" size (Toddler 10 - 13)', 'finish_type_cm':'17 - 19 cm size (Toddler 10 - 13)', 'total_len_in_meters_at_min_sts':'87'},
    {'project_type':'baby_and_kids_socks', 'finish_type_val':'7-5-9-5-size-children-1-6', 'finish_type_inch':'7.5 - 9.5" size (Children 1 - 6)', 'finish_type_cm':'19 - 24 cm size (Children 1 - 6)', 'total_len_in_meters_at_min_sts':'111'},
    {'project_type':'baby_and_kids_vests', 'finish_type_val':'20-chest-size-6-months', 'finish_type_inch':'20" chest size (6 months)', 'finish_type_cm':'50.5 cm chest size (6 months)', 'total_len_in_meters_at_min_sts':'112'},
    {'project_type':'baby_and_kids_vests', 'finish_type_val':'22-chest-size-12-months', 'finish_type_inch':'22" chest size (12 months)', 'finish_type_cm':'56 cm chest size (12 months)', 'total_len_in_meters_at_min_sts':'129'},
    {'project_type':'baby_and_kids_vests', 'finish_type_val':'24-chest-size-18-months', 'finish_type_inch':'24" chest size (18 months)', 'finish_type_cm':'61 cm chest size (18 months)', 'total_len_in_meters_at_min_sts':'138'},
    {'project_type':'baby_and_kids_vests', 'finish_type_val':'25-chest-size-2', 'finish_type_inch':'25" chest size (2)', 'finish_type_cm':'63.5 cm chest size (2)', 'total_len_in_meters_at_min_sts':'148'},
    {'project_type':'baby_and_kids_vests', 'finish_type_val':'27-chest-size-4', 'finish_type_inch':'27" chest size (4)', 'finish_type_cm':'68.5 cm chest size (4)', 'total_len_in_meters_at_min_sts':'173'},
    {'project_type':'baby_and_kids_vests', 'finish_type_val':'29-chest-size-6', 'finish_type_inch':'29" chest size (6)', 'finish_type_cm':'73.5 cm chest size (6)', 'total_len_in_meters_at_min_sts':'208'},
    {'project_type':'baby_and_kids_vests', 'finish_type_val':'31-chest-size-8', 'finish_type_inch':'31" chest size (8)', 'finish_type_cm':'78.5 cm chest size (8)', 'total_len_in_meters_at_min_sts':'243'},
    {'project_type':'baby_and_kids_vests', 'finish_type_val':'33-chest-size-10', 'finish_type_inch':'33" chest size (10)', 'finish_type_cm':'84 cm chest size (10)', 'total_len_in_meters_at_min_sts':'291'},
    {'project_type':'baby_and_kids_vests', 'finish_type_val':'35-chest-size-12', 'finish_type_inch':'35" chest size (12)', 'finish_type_cm':'89 cm chest size (12)', 'total_len_in_meters_at_min_sts':'324'},
    {'project_type':'blankets', 'finish_type_val':'24-x-30-size-stroller-blanket', 'finish_type_inch':'24 x 30" size (Stroller Blanket)', 'finish_type_cm':'61 x 76 cm size (Stroller Blanket)', 'total_len_in_meters_at_min_sts':'232'},
    {'project_type':'blankets', 'finish_type_val':'28-x-36-size-lap-blanket', 'finish_type_inch':'28 x 36" size (Lap Blanket)', 'finish_type_cm':'71 x 92 cm size (Lap Blanket)', 'total_len_in_meters_at_min_sts':'325'},
    {'project_type':'blankets', 'finish_type_val':'36-x-36-size-crib-blanket', 'finish_type_inch':'36 x 36" size (Crib Blanket)', 'finish_type_cm':'92 x 92 cm size (Crib Blanket)', 'total_len_in_meters_at_min_sts':'418'},
    {'project_type':'blankets', 'finish_type_val':'36-x-48-size-baby-blanket', 'finish_type_inch':'36 x 48" size (Baby Blanket)', 'finish_type_cm':'92 x 122 cm size (Baby Blanket)', 'total_len_in_meters_at_min_sts':'557'},
    {'project_type':'blankets', 'finish_type_val':'48-x-60-size-afghan', 'finish_type_inch':'48 x 60" size (Afghan)', 'finish_type_cm':'122 x 153 cm size (Afghan)', 'total_len_in_meters_at_min_sts':'929'},
    {'project_type':'blankets', 'finish_type_val':'52-x-70-size-afghan-large', 'finish_type_inch':'52 x 70" size (Afghan (Large))', 'finish_type_cm':'132 x 178 cm size (Afghan (Large))', 'total_len_in_meters_at_min_sts':'1174'},
    {'project_type':'hats', 'finish_type_val':'14-head-circ-baby', 'finish_type_inch':'14" head circ. (Baby)', 'finish_type_cm':'35.5 cm head circ. (Baby)', 'total_len_in_meters_at_min_sts':'56'},
    {'project_type':'hats', 'finish_type_val':'16-head-circ-toddler', 'finish_type_inch':'16" head circ. (Toddler)', 'finish_type_cm':'40.5 cm head circ. (Toddler)', 'total_len_in_meters_at_min_sts':'61'},
    {'project_type':'hats', 'finish_type_val':'18-head-circ-child', 'finish_type_inch':'18" head circ. (Child)', 'finish_type_cm':'45.5 cm head circ. (Child)', 'total_len_in_meters_at_min_sts':'65'},
    {'project_type':'hats', 'finish_type_val':'20-head-circ-women', 'finish_type_inch':'20" head circ. (Women)', 'finish_type_cm':'51 cm head circ. (Women)', 'total_len_in_meters_at_min_sts':'70'},
    {'project_type':'hats', 'finish_type_val':'22-head-circ-men', 'finish_type_inch':'22" head circ. (Men)', 'finish_type_cm':'56 cm head circ. (Men)', 'total_len_in_meters_at_min_sts':'76'},
    {'project_type':'mens_cardigans', 'finish_type_val':'36-chest-size-x-small', 'finish_type_inch':'36" chest size (x-small)', 'finish_type_cm':'91.5 cm chest size (x-small)', 'total_len_in_meters_at_min_sts':'536'},
    {'project_type':'mens_cardigans', 'finish_type_val':'40-chest-size-small', 'finish_type_inch':'40" chest size (small)', 'finish_type_cm':'101.5 cm chest size (small)', 'total_len_in_meters_at_min_sts':'595'},
    {'project_type':'mens_cardigans', 'finish_type_val':'44-chest-size-medium', 'finish_type_inch':'44" chest size (medium)', 'finish_type_cm':'111.5 cm chest size (medium)', 'total_len_in_meters_at_min_sts':'663'},
    {'project_type':'mens_cardigans', 'finish_type_val':'48-chest-size-large', 'finish_type_inch':'48" chest size (large)', 'finish_type_cm':'122 cm chest size (large)', 'total_len_in_meters_at_min_sts':'744'},
    {'project_type':'mens_cardigans', 'finish_type_val':'52-chest-size-x-large', 'finish_type_inch':'52" chest size (x-large)', 'finish_type_cm':'132 cm chest size (x-large)', 'total_len_in_meters_at_min_sts':'853'},
    {'project_type':'mens_cardigans', 'finish_type_val':'56-chest-size-2x-large', 'finish_type_inch':'56" chest size (2x-large)', 'finish_type_cm':'142 cm chest size (2x-large)', 'total_len_in_meters_at_min_sts':'962'},
    {'project_type':'mens_pullovers', 'finish_type_val':'36-chest-size-x-small', 'finish_type_inch':'36" chest size (x-small)', 'finish_type_cm':'91.5 cm chest size (x-small)', 'total_len_in_meters_at_min_sts':'510'},
    {'project_type':'mens_pullovers', 'finish_type_val':'40-chest-size-small', 'finish_type_inch':'40" chest size (small)', 'finish_type_cm':'101.5 cm chest size (small)', 'total_len_in_meters_at_min_sts':'567'},
    {'project_type':'mens_pullovers', 'finish_type_val':'44-chest-size-medium', 'finish_type_inch':'44" chest size (medium)', 'finish_type_cm':'111.5 cm chest size (medium)', 'total_len_in_meters_at_min_sts':'631'},
    {'project_type':'mens_pullovers', 'finish_type_val':'48-chest-size-large', 'finish_type_inch':'48" chest size (large)', 'finish_type_cm':'122 cm chest size (large)', 'total_len_in_meters_at_min_sts':'709'},
    {'project_type':'mens_pullovers', 'finish_type_val':'52-chest-size-x-large', 'finish_type_inch':'52" chest size (x-large)', 'finish_type_cm':'132 cm chest size (x-large)', 'total_len_in_meters_at_min_sts':'812'},
    {'project_type':'mens_pullovers', 'finish_type_val':'56-chest-size-2x-large', 'finish_type_inch':'56" chest size (2x-large)', 'finish_type_cm':'142 cm chest size (2x-large)', 'total_len_in_meters_at_min_sts':'916'},
    {'project_type':'mens_vests', 'finish_type_val':'36-chest-size-x-small', 'finish_type_inch':'36" chest size (x-small)', 'finish_type_cm':'91.5 cm chest size (x-small)', 'total_len_in_meters_at_min_sts':'393'},
    {'project_type':'mens_vests', 'finish_type_val':'40-chest-size-small', 'finish_type_inch':'40" chest size (small)', 'finish_type_cm':'101.5 cm chest size (small)', 'total_len_in_meters_at_min_sts':'446'},
    {'project_type':'mens_vests', 'finish_type_val':'44-chest-size-medium', 'finish_type_inch':'44" chest size (medium)', 'finish_type_cm':'111.5 cm chest size (medium)', 'total_len_in_meters_at_min_sts':'506'},
    {'project_type':'mens_vests', 'finish_type_val':'48-chest-size-large', 'finish_type_inch':'48" chest size (large)', 'finish_type_cm':'122 cm chest size (large)', 'total_len_in_meters_at_min_sts':'580'},
    {'project_type':'mens_vests', 'finish_type_val':'52-chest-size-x-large', 'finish_type_inch':'52" chest size (x-large)', 'finish_type_cm':'132 cm chest size (x-large)', 'total_len_in_meters_at_min_sts':'678'},
    {'project_type':'mens_vests', 'finish_type_val':'56-chest-size-2x-large', 'finish_type_inch':'56" chest size (2x-large)', 'finish_type_cm':'142 cm chest size (2x-large)', 'total_len_in_meters_at_min_sts':'779'},
    {'project_type':'mens_vests', 'finish_type_val':'child-s-small', 'finish_type_inch':'Child\'s Small', 'finish_type_cm':'Child\'s Small', 'total_len_in_meters_at_min_sts':'59'},
    {'project_type':'mens_vests', 'finish_type_val':'child-s-large', 'finish_type_inch':'Child\'s Large', 'finish_type_cm':'Child\'s Large', 'total_len_in_meters_at_min_sts':'78'},
    {'project_type':'mens_vests', 'finish_type_val':'adult-small', 'finish_type_inch':'Adult Small', 'finish_type_cm':'Adult Small', 'total_len_in_meters_at_min_sts':'114'},
    {'project_type':'mens_vests', 'finish_type_val':'adult-large', 'finish_type_inch':'Adult Large', 'finish_type_cm':'Adult Large', 'total_len_in_meters_at_min_sts':'128'},
    {'project_type':'mittens_and_gloves', 'finish_type_val':'child-s-small', 'finish_type_inch':'Child\'s Small', 'finish_type_cm':'Child\'s Small', 'total_len_in_meters_at_min_sts':'59'},
    {'project_type':'mittens_and_gloves', 'finish_type_val':'child-s-large', 'finish_type_inch':'Child\'s Large', 'finish_type_cm':'Child\'s Large', 'total_len_in_meters_at_min_sts':'78'},
    {'project_type':'mittens_and_gloves', 'finish_type_val':'adult-small', 'finish_type_inch':'Adult Small', 'finish_type_cm':'Adult Small', 'total_len_in_meters_at_min_sts':'114'},
    {'project_type':'mittens_and_gloves', 'finish_type_val':'adult-large', 'finish_type_inch':'Adult Large', 'finish_type_cm':'Adult Large', 'total_len_in_meters_at_min_sts':'128'},
    {'project_type':'scarves', 'finish_type_val':'4-x-48', 'finish_type_inch':'4 x 48"', 'finish_type_cm':'10 x 122 cm', 'total_len_in_meters_at_min_sts':'62'},
    {'project_type':'scarves', 'finish_type_val':'4-x-60', 'finish_type_inch':'4 x 60"', 'finish_type_cm':'10 x 152 cm', 'total_len_in_meters_at_min_sts':'77'},
    {'project_type':'scarves', 'finish_type_val':'4-x-70', 'finish_type_inch':'4 x 70"', 'finish_type_cm':'10 x 178 cm', 'total_len_in_meters_at_min_sts':'90'},
    {'project_type':'scarves', 'finish_type_val':'5-x-48', 'finish_type_inch':'5 x 48"', 'finish_type_cm':'12.5 x 122 cm', 'total_len_in_meters_at_min_sts':'77'},
    {'project_type':'scarves', 'finish_type_val':'5-x-60', 'finish_type_inch':'5 x 60"', 'finish_type_cm':'12.5 x 152 cm', 'total_len_in_meters_at_min_sts':'97'},
    {'project_type':'scarves', 'finish_type_val':'5-x-70', 'finish_type_inch':'5 x 70"', 'finish_type_cm':'12.5 x 178 cm', 'total_len_in_meters_at_min_sts':'113'},
    {'project_type':'scarves', 'finish_type_val':'5-x-100', 'finish_type_inch':'5 x 100"', 'finish_type_cm':'12.5 x 254 cm', 'total_len_in_meters_at_min_sts':'161'},
    {'project_type':'scarves', 'finish_type_val':'6-x-48', 'finish_type_inch':'6 x 48"', 'finish_type_cm':'15 x 122 cm', 'total_len_in_meters_at_min_sts':'93'},
    {'project_type':'scarves', 'finish_type_val':'6-x-60', 'finish_type_inch':'6 x 60"', 'finish_type_cm':'15 x 152 cm', 'total_len_in_meters_at_min_sts':'116'},
    {'project_type':'scarves', 'finish_type_val':'6-x-70', 'finish_type_inch':'6 x 70"', 'finish_type_cm':'15 x 178 cm', 'total_len_in_meters_at_min_sts':'135'},
    {'project_type':'scarves', 'finish_type_val':'6-x-100', 'finish_type_inch':'6 x 100"', 'finish_type_cm':'15 x 254 cm', 'total_len_in_meters_at_min_sts':'194'},
    {'project_type':'scarves', 'finish_type_val':'8-x-48', 'finish_type_inch':'8 x 48"', 'finish_type_cm':'20 x 122 cm', 'total_len_in_meters_at_min_sts':'124'},
    {'project_type':'scarves', 'finish_type_val':'8-x-60', 'finish_type_inch':'8 x 60"', 'finish_type_cm':'20 x 152 cm', 'total_len_in_meters_at_min_sts':'155'},
    {'project_type':'scarves', 'finish_type_val':'8-x-70', 'finish_type_inch':'8 x 70"', 'finish_type_cm':'20 x 178 cm', 'total_len_in_meters_at_min_sts':'181'},
    {'project_type':'scarves', 'finish_type_val':'8-x-100', 'finish_type_inch':'8 x 100"', 'finish_type_cm':'20 x 254 cm', 'total_len_in_meters_at_min_sts':'258'},
    {'project_type':'shawls_and_wraps', 'finish_type_val':'16-x-60', 'finish_type_inch':'16 x 60"', 'finish_type_cm':'40.5 x 152 cm', 'total_len_in_meters_at_min_sts':'310'},
    {'project_type':'shawls_and_wraps', 'finish_type_val':'16-x-70', 'finish_type_inch':'16 x 70"', 'finish_type_cm':'40.5 x 178 cm', 'total_len_in_meters_at_min_sts':'361'},
    {'project_type':'shawls_and_wraps', 'finish_type_val':'18-x-60', 'finish_type_inch':'18 x 60"', 'finish_type_cm':'45.5 x 152 cm', 'total_len_in_meters_at_min_sts':'348'},
    {'project_type':'shawls_and_wraps', 'finish_type_val':'18-x-70', 'finish_type_inch':'18 x 70"', 'finish_type_cm':'45.5 x 178 cm', 'total_len_in_meters_at_min_sts':'406'},
    {'project_type':'shawls_and_wraps', 'finish_type_val':'20-x-60', 'finish_type_inch':'20 x 60"', 'finish_type_cm':'51 x 152 cm', 'total_len_in_meters_at_min_sts':'387'},
    {'project_type':'shawls_and_wraps', 'finish_type_val':'20-x-70', 'finish_type_inch':'20 x 70"', 'finish_type_cm':'51 x 178 cm', 'total_len_in_meters_at_min_sts':'452'},
    {'project_type':'shawls_and_wraps', 'finish_type_val':'26-x-60', 'finish_type_inch':'26 x 60"', 'finish_type_cm':'66 x 152 cm', 'total_len_in_meters_at_min_sts':'503'},
    {'project_type':'shawls_and_wraps', 'finish_type_val':'26-x-70', 'finish_type_inch':'26 x 70"', 'finish_type_cm':'66 x 178 cm', 'total_len_in_meters_at_min_sts':'587'},
    {'project_type':'socks', 'finish_type_val':'women-s-adult', 'finish_type_inch':'Women\'s Adult', 'finish_type_cm':'Women\'s Adult', 'total_len_in_meters_at_min_sts':'161'},
    {'project_type':'socks', 'finish_type_val':'mens-small-medium', 'finish_type_inch':'Mens Small / Medium', 'finish_type_cm':'Mens Small / Medium', 'total_len_in_meters_at_min_sts':'201'},
    {'project_type':'socks', 'finish_type_val':'mens-large', 'finish_type_inch':'Mens Large', 'finish_type_cm':'Mens Large', 'total_len_in_meters_at_min_sts':'201'},
    {'project_type':'womens_cardigans', 'finish_type_val':'32-chest-size-x-small', 'finish_type_inch':'32" chest size (x-small)', 'finish_type_cm':'81 cm chest size (x-small)', 'total_len_in_meters_at_min_sts':'535'},
    {'project_type':'womens_cardigans', 'finish_type_val':'36-chest-size-small', 'finish_type_inch':'36" chest size (small)', 'finish_type_cm':'91.5 cm chest size (small)', 'total_len_in_meters_at_min_sts':'578'},
    {'project_type':'womens_cardigans', 'finish_type_val':'40-chest-size-medium', 'finish_type_inch':'40" chest size (medium)', 'finish_type_cm':'101.5 cm chest size (medium)', 'total_len_in_meters_at_min_sts':'622'},
    {'project_type':'womens_cardigans', 'finish_type_val':'44-chest-size-large', 'finish_type_inch':'44" chest size (large)', 'finish_type_cm':'111.5 cm chest size (large)', 'total_len_in_meters_at_min_sts':'667'},
    {'project_type':'womens_cardigans', 'finish_type_val':'48-chest-size-x-large', 'finish_type_inch':'48" chest size (x-large)', 'finish_type_cm':'122 cm chest size (x-large)', 'total_len_in_meters_at_min_sts':'709'},
    {'project_type':'womens_cardigans', 'finish_type_val':'52-chest-size-2x-large', 'finish_type_inch':'52" chest size (2x-large)', 'finish_type_cm':'132 cm chest size (2x-large)', 'total_len_in_meters_at_min_sts':'753'},
    {'project_type':'womens_cardigans', 'finish_type_val':'56-chest-size-3x-large', 'finish_type_inch':'56" chest size (3x-large)', 'finish_type_cm':'142 cm chest size (3x-large)', 'total_len_in_meters_at_min_sts':'797'},
    {'project_type':'womens_pullovers', 'finish_type_val':'32-chest-size-x-small', 'finish_type_inch':'32" chest size (x-small)', 'finish_type_cm':'81 cm chest size (x-small)', 'total_len_in_meters_at_min_sts':'509'},
    {'project_type':'womens_pullovers', 'finish_type_val':'36-chest-size-small', 'finish_type_inch':'36" chest size (small)', 'finish_type_cm':'91.5 cm chest size (small)', 'total_len_in_meters_at_min_sts':'551'},
    {'project_type':'womens_pullovers', 'finish_type_val':'40-chest-size-medium', 'finish_type_inch':'40" chest size (medium)', 'finish_type_cm':'101.5 cm chest size (medium)', 'total_len_in_meters_at_min_sts':'592'},
    {'project_type':'womens_pullovers', 'finish_type_val':'44-chest-size-large', 'finish_type_inch':'44" chest size (large)', 'finish_type_cm':'111.5 cm chest size (large)', 'total_len_in_meters_at_min_sts':'634'},
    {'project_type':'womens_pullovers', 'finish_type_val':'48-chest-size-x-large', 'finish_type_inch':'48" chest size (x-large)', 'finish_type_cm':'122 cm chest size (x-large)', 'total_len_in_meters_at_min_sts':'675'},
    {'project_type':'womens_pullovers', 'finish_type_val':'52-chest-size-2x-large', 'finish_type_inch':'52" chest size (2x-large)', 'finish_type_cm':'132 cm chest size (2x-large)', 'total_len_in_meters_at_min_sts':'717'},
    {'project_type':'womens_pullovers', 'finish_type_val':'56-chest-size-3x-large', 'finish_type_inch':'56" chest size (3x-large)', 'finish_type_cm':'142 cm chest size (3x-large)', 'total_len_in_meters_at_min_sts':'759'},
    {'project_type':'womens_vests', 'finish_type_val':'32-chest-size-x-small', 'finish_type_inch':'32" chest size (x-small)', 'finish_type_cm':'81 cm chest size (x-small)', 'total_len_in_meters_at_min_sts':'356'},
    {'project_type':'womens_vests', 'finish_type_val':'36-chest-size-small', 'finish_type_inch':'36" chest size (small)', 'finish_type_cm':'91.5 cm chest size (small)', 'total_len_in_meters_at_min_sts':'392'},
    {'project_type':'womens_vests', 'finish_type_val':'40-chest-size-medium', 'finish_type_inch':'40" chest size (medium)', 'finish_type_cm':'101.5 cm chest size (medium)', 'total_len_in_meters_at_min_sts':'428'},
    {'project_type':'womens_vests', 'finish_type_val':'44-chest-size-large', 'finish_type_inch':'44" chest size (large)', 'finish_type_cm':'111.5 cm chest size (large)', 'total_len_in_meters_at_min_sts':'466'},
    {'project_type':'womens_vests', 'finish_type_val':'48-chest-size-x-large', 'finish_type_inch':'48" chest size (x-large)', 'finish_type_cm':'122 cm chest size (x-large)', 'total_len_in_meters_at_min_sts':'504'},
    {'project_type':'womens_vests', 'finish_type_val':'52-chest-size-2x-large', 'finish_type_inch':'52" chest size (2x-large)', 'finish_type_cm':'132 cm chest size (2x-large)', 'total_len_in_meters_at_min_sts':'544'},
    {'project_type':'womens_vests', 'finish_type_val':'56-chest-size-3x-large', 'finish_type_inch':'56" chest size (3x-large)', 'finish_type_cm':'142 cm chest size (3x-large)', 'total_len_in_meters_at_min_sts':'584'},
  ];
  const $gauge_socks_selection_inches = [
    {'option_title': '4 sts / inch (Heavy Worsted)'},
    {'option_title': '4.5 sts / inch (Heavy Worsted)'},
    {'option_title': '5 sts / inch (Worsted)'},
    {'option_title': '5.5 sts / inch (DK)'},
    {'option_title': '6 sts / inch (Sport)'},
    {'option_title': '7 sts / inch  (Fingering)'},
    {'option_title': '8 sts / inch  (Lace)'}
  ];
  const $gauge_selection_inches = [
    {'option_title': '2 sts / inch (Super Bulky)'},
    {'option_title': '3 sts / inch (Bulky)'},
    {'option_title': '3.5 sts / inch (Bulky)'},
    {'option_title': '4 sts / inch (Heavy Worsted)'},
    {'option_title': '4.5 sts / inch (Heavy Worsted)'},
    {'option_title': '5 sts / inch (Worsted)'},
    {'option_title': '5.5 sts / inch (DK)'},
    {'option_title': '6 sts / inch (Sport)'},
  ];
  const $gauge_socks_selection_cm = [
    {'option_title': '16 sts / 10 cm  (Heavy Worsted)', 'value': '4 sts / inch (Heavy Worsted)'},
    {'option_title': '18 sts / 10 cm  (Heavy Worsted)', 'value': '4.5 sts / inch (Heavy Worsted)'},
    {'option_title': '20 sts / 10 cm  (Worsted)', 'value': '5 sts / inch (Worsted)'},
    {'option_title': '22 sts / 10 cm  (DK)', 'value': '5.5 sts / inch (DK)'},
    {'option_title': '24 sts / 10 cm  (Sport)', 'value': '6 sts / inch (Sport)'},
    {'option_title': '28 sts / 10 cm  (Fingering)', 'value': '7 sts / inch  (Fingering)'},
    {'option_title': '32 sts / 10 cm  (Lace)', 'value': '8 sts / inch  (Lace)'}
  ];
  const $gauge_selection_cm = [
    {'option_title': '8 sts / 10 cm  (Super Bulky)', 'value': '2 sts / inch (Super Bulky)'},
    {'option_title': '12 sts / 10 cm  (Bulky)', 'value': '3 sts / inch (Bulky)'},
    {'option_title': '14 sts / 10 cm  (Bulky)', 'value': '3.5 sts / inch (Bulky)'},
    {'option_title': '16 sts / 10 cm  (Heavy Worsted)', 'value': '4 sts / inch (Heavy Worsted)'},
    {'option_title': '18 sts / 10 cm  (Heavy Worsted)', 'value': '4.5 sts / inch (Heavy Worsted)'},
    {'option_title': '20 sts / 10 cm  (Worsted)', 'value': '5 sts / inch (Worsted)'},
    {'option_title': '22 sts / 10 cm  (DK)', 'value': '5.5 sts / inch (DK)'},
    {'option_title': '24 sts / 10 cm  (Sport)', 'value': '6 sts / inch (Sport)'},
  ];
  const $calculation_sockes_values = [
    {'option_title': '4-sts-inch-heavy-worsted','STS_PER_INCH' : '4','ROWS_PER_INCH' : '6','STS_PER_10CM' : '16','ROWS_PER_10CM' : '24','BASELINE_TOTAL_CM' : '3300','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '4-5-sts-inch-heavy-worsted','STS_PER_INCH' : '4.5','ROWS_PER_INCH' : '6','STS_PER_10CM' : '18','ROWS_PER_10CM' : '24','BASELINE_TOTAL_CM' : '3545','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '5-sts-inch-worsted','STS_PER_INCH' : '5','ROWS_PER_INCH' : '7.5','STS_PER_10CM' : '20','ROWS_PER_10CM' : '30','BASELINE_TOTAL_CM' : '4400','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '5-5-sts-inch-dk','STS_PER_INCH' : '5.5','ROWS_PER_INCH' : '7.5','STS_PER_10CM' : '22','ROWS_PER_10CM' : '30','BASELINE_TOTAL_CM' : '5060','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '6-sts-inch-sport','STS_PER_INCH' : '6','ROWS_PER_INCH' : '8','STS_PER_10CM' : '24','ROWS_PER_10CM' : '32','BASELINE_TOTAL_CM' : '6250','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '7-sts-inch-fingering','STS_PER_INCH' : '7','ROWS_PER_INCH' : '9.5','STS_PER_10CM' : '28','ROWS_PER_10CM' : '38','BASELINE_TOTAL_CM' : '6875','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '8-sts-inch-lace','STS_PER_INCH' : '8','ROWS_PER_INCH' : '11','STS_PER_10CM' : '32','ROWS_PER_10CM' : '44','BASELINE_TOTAL_CM' : '7500','BASELINE_TOTAL_SQ_CM' : '400'}
  ];
  const $calculation_values = [
    {'option_title': '2-sts-inch-super-bulky','STS_PER_INCH' : '2','ROWS_PER_INCH' : '2.5','STS_PER_10CM' : '8','ROWS_PER_10CM' : '10','BASELINE_TOTAL_CM' : '1818','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '3-sts-inch-bulky','STS_PER_INCH' : '3','ROWS_PER_INCH' : '4','STS_PER_10CM' : '12','ROWS_PER_10CM' : '16','BASELINE_TOTAL_CM' : '2278','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '3-5-sts-inch-bulky','STS_PER_INCH' : '3.5','ROWS_PER_INCH' : '4.5','STS_PER_10CM' : '14','ROWS_PER_10CM' : '18','BASELINE_TOTAL_CM' : '2598','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '4-sts-inch-heavy-worsted','STS_PER_INCH' : '4','ROWS_PER_INCH' : '6','STS_PER_10CM' : '16','ROWS_PER_10CM' : '24','BASELINE_TOTAL_CM' : '3300','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '4-5-sts-inch-heavy-worsted','STS_PER_INCH' : '4.5','ROWS_PER_INCH' : '6','STS_PER_10CM' : '18','ROWS_PER_10CM' : '24','BASELINE_TOTAL_CM' : '3545','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '5-sts-inch-worsted','STS_PER_INCH' : '5','ROWS_PER_INCH' : '7.5','STS_PER_10CM' : '20','ROWS_PER_10CM' : '30','BASELINE_TOTAL_CM' : '4400','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '5-5-sts-inch-dk','STS_PER_INCH' : '5.5','ROWS_PER_INCH' : '7.5','STS_PER_10CM' : '22','ROWS_PER_10CM' : '30','BASELINE_TOTAL_CM' : '5060','BASELINE_TOTAL_SQ_CM' : '400'},
    {'option_title': '6-sts-inch-sport','STS_PER_INCH' : '6','ROWS_PER_INCH' : '8','STS_PER_10CM' : '24','ROWS_PER_10CM' : '32','BASELINE_TOTAL_CM' : '6250','BASELINE_TOTAL_SQ_CM' : '400'}
  ];

  const $check_option_selection = () => {
    const $mm_type_val = document.querySelector('#measurementType').value;
    const $project_type_val = document.querySelector('#projectType').value;
    const $finished_type_val = document.querySelector('#finishedSize').value;
    const $gauge_val = document.querySelector('#gauge_selection').value;
    if($mm_type_val != '' && $project_type_val != '' && $finished_type_val != '' && $gauge_val != ''){
      document.querySelector('.crochet_knitting_calculator_btn').classList.remove('disabled_btn_css');
    }else{
      if(!document.querySelector('.crochet_knitting_calculator_btn').classList.contains('disabled_btn_css')){
        document.querySelector('.crochet_knitting_calculator_btn').classList.add('disabled_btn_css');
      }
    }
  }
  
  if(document.querySelector('#measurementType')){
    document.querySelectorAll('#measurementType').forEach(($this_select) => {
      $this_select.addEventListener('change', function(event){
        event.preventDefault(), event.stopImmediatePropagation();
        const $mm_type = $this_select.options[$this_select.selectedIndex].value;
        document.querySelector('#projectType').value = 'empty';
        document.querySelector('#finishedSize').innerHTML = '<option value="" disabled selected>Finished Size *</option>';
        document.querySelector('#finishedSize').setAttribute('disabled', 'disabled');
        const $gauge_option = ($mm_type == 'cm') ? '<option value="" disabled selected>Gauge (sts/10 cm) *</option>' : '<option value="" disabled selected>Gauge (sts/inch) *</option>';
        document.querySelector('#gauge_selection').innerHTML = $gauge_option;
        document.querySelector('#gauge_selection').setAttribute('disabled', 'disabled');
        $check_option_selection();
      });
    });
  }
  if(document.querySelector('#projectType')){
    document.querySelectorAll('#projectType').forEach(($this_select) => {
      $this_select.addEventListener('change', function(event){
        event.preventDefault(), event.stopImmediatePropagation();
        const $mm_type = document.querySelector('#measurementType').value;
        const $project_type = $this_select.options[$this_select.selectedIndex].value;
        let $finish_size_options = '<option value="" disabled selected>Finished Size *</option>';
        ($finish_sizes || []).map(($finish_val, $finish_idx) => {
          if($finish_val.project_type == $project_type){
            const $option_title = ($mm_type == 'cm') ? $finish_val.finish_type_cm : $finish_val.finish_type_inch;
            $finish_size_options += '<option value="'+$finish_val.finish_type_val+'">'+$option_title+'</option>';
          }
        });
        document.querySelector('#finishedSize').innerHTML = $finish_size_options;
        document.querySelector('#finishedSize').removeAttribute('disabled');
        $check_option_selection();
      });
    });
  }
  if(document.querySelector('#finishedSize')){
    document.querySelectorAll('#finishedSize').forEach(($this_select) => {
      $this_select.addEventListener('change', function(event){
        event.preventDefault(), event.stopImmediatePropagation();
        const $mm_type = document.querySelector('#measurementType').value;
        const $project_type = document.querySelector('#projectType').value;
        let $gauge_option_cm_values = $gauge_selection_cm, $gauge_option_inches_values = $gauge_selection_inches;
        if($project_type == 'baby_and_kids_socks' || $project_type == 'mittens_and_gloves'){
          $gauge_option_cm_values = $gauge_socks_selection_cm;
          $gauge_option_inches_values = $gauge_socks_selection_inches;
        }
        let $gauge_options = '';
        if($mm_type == 'cm'){
          $gauge_options += '<option value="" disabled selected>Gauge (sts/10 cm) *</option>';
          ($gauge_option_cm_values || []).map(($gauge_val, $gauge_idx) => {
            const $option_val = $gauge_val.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            $gauge_options += '<option value="'+$option_val+'">'+$gauge_val.option_title+'</option>';
          });
        }else{
          $gauge_options += '<option value="" disabled selected>Gauge (sts/inch) *</option>';
          ($gauge_option_inches_values || []).map(($gauge_val, $gauge_idx) => {
            const $option_val = $gauge_val.option_title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            $gauge_options += '<option value="'+$option_val+'">'+$gauge_val.option_title+'</option>';
          });
        }
        document.querySelector('#gauge_selection').innerHTML = $gauge_options;
        document.querySelector('#gauge_selection').removeAttribute('disabled');
        $check_option_selection();
      });
    });
  }
  if(document.querySelector('#gauge_selection')){
    document.querySelectorAll('#gauge_selection').forEach(($this_select) => {
      $this_select.addEventListener('change', function(event){
        event.preventDefault(), event.stopImmediatePropagation();
        $check_option_selection();
      });
    });
  }
  
  if(document.querySelector('.crochet_knitting_calculator_reset')){
    document.querySelectorAll('.crochet_knitting_calculator_reset').forEach(($this_reset) => {
      $this_reset.addEventListener('click', function(event){
        event.preventDefault(), event.stopImmediatePropagation();
        $this_reset.closest('#crochet_knitting_calculator_form').querySelector('#measurementType').value = 'inches';
        $this_reset.closest('#crochet_knitting_calculator_form').querySelector('#measurementType').dispatchEvent(new Event('change'));
      });
    });
  }

  const $convertCMToYards = ($cmToConvert) => {
    let $newValue = 0;
    if($cmToConvert != null){
      $newValue = (($cmToConvert / 2.54) / 36);
    }
    return $newValue;
  }

  const $convertCMToYardsCrochet = ($cmToConvert) => {
    let $newValue = 0;
    if($cmToConvert != null){
      $newValue =  ((($cmToConvert / 2.54) / 36) * 1.25);
    }
    return $newValue;
  }

  const $knitting_suggested_products = async () => {
    const $gauge_text = document.querySelector('#gauge_selection').options[document.querySelector('#gauge_selection').selectedIndex].text;
    let $suggested_collection_url = '';
    if($gauge_text.includes('(Super Bulky)')){
      $suggested_collection_url = '/collections/super_bulky_yarn?view=calculator';
    } else if($gauge_text.includes('(Bulky)')){
      $suggested_collection_url = '/collections/bulky_yarn?view=calculator';
    } else if($gauge_text.includes('(Heavy Worsted)')){
      $suggested_collection_url = '/collections/heavy_worsted_yarn?view=calculator';
    } else if($gauge_text.includes('(Worsted)')){
      $suggested_collection_url = '/collections/worsted_yarn?view=calculator';
    } else if($gauge_text.includes('(DK)')){
      $suggested_collection_url = '/collections/dk_yarn?view=calculator';
    } else if($gauge_text.includes('(Sport)')){
      $suggested_collection_url = '/collections/sport_yarn?view=calculator';
    } else if($gauge_text.includes('((Fingering))')){
      $suggested_collection_url = '/collections/fingering-yarn?view=calculator';
    } else if($gauge_text.includes('((Lace))')){
      $suggested_collection_url = '/collections/lace_yarn?view=calculator';
    }
    fetch($suggested_collection_url).then(response => response.text()).then((response) => {
      document.querySelector('.recommended-product-wrapper').innerHTML = response;
    }).catch(err => console.log(err));
  }
      
  if(document.querySelector('.crochet_knitting_calculator_btn')){
    document.querySelectorAll('.crochet_knitting_calculator_btn').forEach(($this_btn) => {
      $this_btn.addEventListener('click', function(event){
        event.preventDefault(), event.stopImmediatePropagation();
        const $mm_type_val = document.querySelector('#measurementType').value;
        const $project_type_val = document.querySelector('#projectType').value;
        const $finished_type_val = document.querySelector('#finishedSize').value;
        const $gauge_val = document.querySelector('#gauge_selection').value;
        let $calculation_default_values = $calculation_values;
        if($project_type_val == 'baby_and_kids_socks' || $project_type_val == 'mittens_and_gloves'){
          $calculation_default_values = $calculation_sockes_values;
        }
        
        var $chosenStsPerSqCM = 0, $chosen_STS_PER_10CM = 0, $chosen_ROWS_PER_10CM = 0, $isFirst = true;
        var $prevStsPerSqCM = 0, $currStsPerSqCM = 0, $currStsPer10CM = 0, $currRowsPer10CM = 0, $currBaselineTotalCM = 0, $currBaselineTotalSQCM = 0, $currTotalSts = 0, $currCMPerStitch = 0, $centimeter_per_stitches_cm = 0, $currTotalLengthInCM = 0, $currPercentIncrease = 0, $prevCMPerSqCM = 0, $currCMPerSqCM = 0, $prevTotalLengthInCM = 0;
        let $chosenStsPer10CM_idx = $calculation_default_values.find(($val) => $val.option_title == $gauge_val);
        console.log('$chosenStsPer10CM_idx: ', $chosenStsPer10CM_idx);
        if($chosenStsPer10CM_idx){
          $chosen_STS_PER_10CM = parseFloat($chosenStsPer10CM_idx.STS_PER_10CM);
          $chosen_ROWS_PER_10CM = parseFloat($chosenStsPer10CM_idx.ROWS_PER_10CM);
          $chosenStsPerSqCM = ($chosen_STS_PER_10CM * $chosen_ROWS_PER_10CM) / 100;
          for(let i=0; i<$calculation_default_values.length; i++){
            $currStsPer10CM = parseFloat($calculation_default_values[i].STS_PER_10CM);
            $currRowsPer10CM = parseFloat($calculation_default_values[i].ROWS_PER_10CM);
            $currBaselineTotalCM = parseFloat($calculation_default_values[i].BASELINE_TOTAL_CM);
            $currBaselineTotalSQCM = parseFloat($calculation_default_values[i].BASELINE_TOTAL_SQ_CM);
            $prevStsPerSqCM = $currStsPerSqCM;
            $currStsPerSqCM = ($currStsPer10CM * $currRowsPer10CM) / 100;
            $currTotalSts = ($currStsPerSqCM * $currBaselineTotalSQCM);
            if($currTotalSts > 0){
              $currCMPerStitch = ($currBaselineTotalCM / $currTotalSts);
            }else{
              $currCMPerStitch = 0;
            }
            $prevCMPerSqCM = $currCMPerSqCM;
            $currCMPerSqCM = ($currStsPerSqCM * $currCMPerStitch);
            if($isFirst){
              $prevStsPerSqCM = $currStsPerSqCM;
              $prevCMPerSqCM = $currCMPerSqCM;
              let $temp_project_type_val = $finish_sizes.find(($val) => ($val.project_type == $project_type_val) && ($val.finish_type_val == $finished_type_val));
              $currTotalLengthInCM = parseFloat($temp_project_type_val.total_len_in_meters_at_min_sts) * 100;
              $prevTotalLengthInCM = $currTotalLengthInCM;
              $isFirst = false;
            }else{
              $prevTotalLengthInCM = $currTotalLengthInCM;
              $currPercentIncrease = ($currCMPerSqCM - $prevCMPerSqCM) / $prevCMPerSqCM;
              $currTotalLengthInCM = ($currTotalLengthInCM * (1 + $currPercentIncrease));
              if($currStsPerSqCM > $chosenStsPerSqCM){
                let $newPercentDifference = 0;
                $newPercentDifference = (($chosenStsPerSqCM - $prevStsPerSqCM) / ($currStsPerSqCM - $prevStsPerSqCM));
                $currTotalLengthInCM = ($prevTotalLengthInCM + (($currTotalLengthInCM - $prevTotalLengthInCM) * $newPercentDifference));
              }
            }
            if($currStsPerSqCM >= $chosenStsPerSqCM){
              $isFirst = true;
              break;
            }
          }
        }
        const $mm_type_msg = ($mm_type_val == 'cm') ? '10 cm' : 'inch';
        const $assumptions_str_message = ($mm_type_val == 'cm') ? parseFloat($chosenStsPer10CM_idx.STS_PER_10CM) : parseFloat($chosenStsPer10CM_idx.STS_PER_INCH);
        const $assumptions_row_message = ($mm_type_val == 'cm') ? parseFloat($chosenStsPer10CM_idx.ROWS_PER_10CM) : parseFloat($chosenStsPer10CM_idx.ROWS_PER_INCH);
        document.querySelector('.knitting_results_meters').innerHTML = parseInt($currTotalLengthInCM / 100);
        document.querySelector('.knitting_results_yard').innerHTML = parseInt($convertCMToYards($currTotalLengthInCM));
        document.querySelector('.crochet_results_meters').innerHTML = parseInt(($currTotalLengthInCM * 1.25) / 100);
        document.querySelector('.crochet_results_yard').innerHTML = parseInt($convertCMToYardsCrochet($currTotalLengthInCM));
        document.querySelector('.assumptions_str_message').innerHTML = $assumptions_str_message+' sts / '+$mm_type_msg;
        document.querySelector('.assumptions_row_message').innerHTML = $assumptions_row_message+' rows / '+$mm_type_msg;
        if($this_btn.closest('.calculator-main').querySelector('.project-results').classList.contains('hidden_project_result')){
          $this_btn.closest('.calculator-main').querySelector('.project-results').classList.remove('hidden_project_result');
        }
        if(document.querySelector('.recommended-product-wrapper')){
          $knitting_suggested_products();
        }
        const $scroll_element = document.querySelector('.project-results');
        const $headerOffset = 90;
        const $elementPosition = $scroll_element.getBoundingClientRect().top;
        const $offsetPosition = $elementPosition + window.pageYOffset - $headerOffset;
        window.scrollTo({
          top: $offsetPosition,
          behavior: "smooth"
        });
      });
    });
  }
}

document.querySelectorAll('.product_variant_colorway').forEach(function (colorway) {
  colorway.querySelectorAll('input').forEach(function (checkbox) {
    checkbox.addEventListener("change", function () { 
      colorwaySelected();
    });
  });
});
function colorwaySelected() {
  document.querySelectorAll('.product_variant_colorway').forEach(function (colorway) {
    var inputCheckedLength = colorway.querySelectorAll('.product_variant_colorway-group input:checked').length; 
    var checkboxValue = '';
    colorway.querySelectorAll('input').forEach(function (checkbox, index) {
      var index = index + 1;
      if(inputCheckedLength != 0) {
        if(checkbox.checked) {
          if(inputCheckedLength < 2) {
            checkboxValue += checkbox.dataset.value;
          }else{
            if(inputCheckedLength === index) {
              checkboxValue += checkbox.dataset.value;    
            }else{
              checkboxValue += checkbox.dataset.value + ', ';
            }
          }
        }
      }else {
        checkboxValue = "";
      }
    });
    colorway.querySelector('.product_variant_colorway-name_list').innerText = checkboxValue;
  });
}
colorwaySelected();

document.querySelectorAll('.product_pattern').forEach(function (pattern) {
  pattern.querySelectorAll('input').forEach(function (radio) {
    radio.addEventListener("change", function () { 
      patternSelected();
    });
  });
});
function patternSelected() {
  document.querySelectorAll('.product_pattern').forEach(function (pattern) {
    var radioValue = '';
    pattern.querySelectorAll('input').forEach(function (radio) {      
      if(radio.checked && radio.dataset.value != '') {
        radioValue += radio.dataset.value;
      }
    });
    pattern.querySelector('.product_pattern-name_list').innerText = radioValue;
  });
}
patternSelected();

if(document.querySelector(".qty_main_product")){
  document.querySelector(".qty_main_product").addEventListener("change",function(input) {
    var inputValue = this.value;
    if(document.querySelectorAll(".product_pattern-group")) {
      document.querySelectorAll(".product_pattern-group").forEach(function (patternGroup) {
        patternGroup.querySelectorAll("input[type=radio]").forEach(function (radio) {
          if(radio.value != '') {
            radio.dataset.qty = inputValue;
          }
        });
        patternGroup.querySelectorAll(".product_pattern_wrapper").forEach(function (patternWrapper) {
          if(patternWrapper.querySelector(".product_pattern_product_quantity span")){
            patternWrapper.querySelector(".product_pattern_product_quantity span").innerText = inputValue;
          }
        });
      });
    }
    if(document.querySelectorAll(".product_variant_colorway-group")) {
      document.querySelectorAll(".product_variant_colorway-group").forEach(function (colorwayGroup) {
        colorwayGroup.querySelectorAll(".product_colorway_product_item").forEach(function (colorwayItem) {
          colorwayItem.dataset.qty = inputValue;
          if(colorwayItem.querySelector('.product_colorway_product_quantity span')){
            colorwayItem.querySelector('.product_colorway_product_quantity span').innerText = inputValue;
          }
        });
      });
    }
    if(document.querySelectorAll(".needles-product")) {
      document.querySelectorAll(".needles-product").forEach(function (needles) {
        needles.querySelector("input[name=needles]").dataset.pqty = inputValue;
        needles.querySelector(".needles-product-infoqty span").innerText = inputValue;
      });
    }
  });
}

const $money_type = '${{amount}}';
const $money_format = function(t,r){function e(t,r){return void 0===t?r:t}function a(t,r,a,o){if(r=e(r,2),a=e(a,","),o=e(o,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(r);let n=t.split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+a)+(n[1]?o+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));let o="",n=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(n)[1]){case"amount":o=a(t,2);break;case"amount_no_decimals":o=a(t,0);break;case"amount_with_comma_separator":o=a(t,2,".",",");break;case"amount_with_space_separator":o=a(t,2," ",",");break;case"amount_with_period_and_space_separator":o=a(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=a(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=a(t,0,".","");break;case"amount_with_space_separator":o=a(t,2,",","");break;case"amount_with_apostrophe_separator":o=a(t,2,"'",".")}return i.replace(n,o)};

function Totalamount() {
  let SelectVARPrice = 0;
  if(document.querySelector(".variant-selects-sizes .Option-kitopt-select")){
    var kitoptsel = document.querySelector(".variant-selects-sizes .Option-kitopt-select");
    SelectVARPrice = parseFloat(kitoptsel.options[kitoptsel.selectedIndex].dataset.otpprice);
  }
  if(document.querySelectorAll('.needles-product-list input[name=needles]:checked')){
    document.querySelectorAll('.needles-product-list input[name=needles]:checked').forEach( (needle) => {
      var RECPRODPRICE = parseFloat(needle.getAttribute('data-nprice'));
      console.log("SelectVARPrice Bettween",RECPRODPRICE);
      SelectVARPrice += RECPRODPRICE;
    });
  }
  if(document.querySelector('.product_pattern input[name="product[pattern]"]:checked')){
    var selectedPattern = document.querySelector('.product_pattern input[name="product[pattern]"]:checked');
    var patternValue = selectedPattern ? selectedPattern.value : "";
    var patternPRICE = selectedPattern ? selectedPattern.getAttribute('data-patprice') : "";
    if(patternValue){
      SelectVARPrice += parseFloat(patternPRICE);
    }
  }
  document.querySelector('.product-form__qtyprice').querySelector('.price_total .price__regular').innerText = $money_format(SelectVARPrice, $money_type);
}

function Totalamountstatic() {
  let SelectVARPricestat = 0;
  if(document.querySelectorAll('.product_variant_colorway-group .colorway-input:checked')){
    document.querySelectorAll('.product_variant_colorway-group .colorway-input:checked').forEach( (colorway) => {
      var RECPRODPRICE = parseFloat(colorway.getAttribute('data-varprice'));
      SelectVARPricestat += RECPRODPRICE;
    });
  }
  if(document.querySelector('.product_pattern input[name="product[pattern]"]:checked')){
    var selectedPattern = document.querySelector('.product_pattern input[name="product[pattern]"]:checked');
    var patternValue = selectedPattern ? selectedPattern.value : "";
    var patternPRICE = selectedPattern ? selectedPattern.getAttribute('data-patprice') : "";
    if(patternValue){
      SelectVARPricestat += parseFloat(patternPRICE);
    }
  }
  document.querySelector('.product-form__qtyprice').querySelector('.price_total .price__regular').innerText = $money_format(SelectVARPricestat, $money_type);
}

if(document.querySelector(".variant-selects-sizes .Option-kitopt-select")){
  var OPTIONSELECT = document.querySelector(".variant-selects-sizes .Option-kitopt-select");
  OPTIONSELECT.addEventListener("change", (kitopt) => {
    var SelectVAL = kitopt.target.value;
    var SelectVARID = kitopt.target.options[kitopt.target.selectedIndex].dataset.id;
  
    Totalamount();
    document.querySelector('.product-form').querySelector('form').querySelector('input[name=id]').value = SelectVARID;
    var SelectOpt = document.querySelector(".product-swatches-shades");
    SelectOpt.querySelectorAll('.value-options-color').forEach((e) => {
      e.classList.remove('varirant-active');
      var DataVal = e.getAttribute('data-value');
      if(DataVal == SelectVAL){
        e.classList.add('varirant-active');
      }
    })
  });
}

document.querySelectorAll('.needles-product-list input[name=needles]').forEach((checkbox) => {
  checkbox.addEventListener('change', Totalamount);
});
document.querySelectorAll('.product_pattern-option input').forEach((checkbox) => {
  checkbox.addEventListener('change', Totalamount);
});
document.querySelectorAll('.product_variant_colorway-group .colorway-input').forEach((checkbox) => {
  checkbox.addEventListener('change', Totalamountstatic);
});
document.querySelectorAll('.product_pattern-static input').forEach((checkbox) => {
  checkbox.addEventListener('change', Totalamountstatic);
});

document.querySelectorAll('.list_product_options input').forEach(e => {
  e.onchange = (event) => {
    var SelectedVal = e.value;
    e.closest('.value-options-color-wrapp').querySelector('.product--selected-shad').value = SelectedVal;
  }
});

/*-----------------*/
if(document.querySelector('.product-kitoption__submit')){
  document.querySelector('.product-kitoption__submit').addEventListener('click', (submit) => {
    submit.stopPropagation();
    submit.preventDefault();

    var form = submit.target.closest('form');
    var MainQuantity = form.querySelector('.qty_main_product').value;
    var PRODID = form.querySelector('input[name=id]').value;
    var selectedShads = document.querySelectorAll('.varirant-active .product--selected-shad');
    var mainProductData = new Array();
    var properties = {};

    selectedShads.forEach(function(input, i) {
      var count = i + 1;
      var value = input.value;
      var dataRqty = input.getAttribute('data-rqty');
      properties[count+". "+value] = dataRqty+" Qty";
    });
    mainProductData.push({
      id: PRODID,
      quantity: MainQuantity,
      properties: properties
    });
    document.querySelectorAll('.needles-product-list input[name=needles]:checked').forEach( (needle) => {
      var variantId = needle.value;
      var Quantity = needle.getAttribute('data-pqty');
      mainProductData.push({
        id: variantId,
        quantity: Quantity
      });
    });

    var selectedPattern = document.querySelector('.product_pattern input[name="product[pattern]"]:checked');
    var patternValue = selectedPattern ? selectedPattern.value : "";
    var patternQTY = selectedPattern ? selectedPattern.getAttribute('data-qty') : "";
    if(patternValue){
      mainProductData.push({
        id: patternValue,
        quantity: patternQTY
      });
    }
    var PatternCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if(PatternCart){
      var formData = {
        'items': mainProductData,
        'sections': PatternCart.getSectionsToRender().map((section) => section.id),
        'sections_url': window.location.pathname
      }
      PatternCart.setActiveElement(document.activeElement);
    }
   
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(response => {
      if(response.message != "" && response.message != null) {
        var productForm = submit.target.closest('product-form');
        var errorMessageWrapper = productForm.querySelector('.product-form__error-message-wrapper');
        var errorMessage = errorMessageWrapper.querySelector('.product-form__error-message');
        errorMessageWrapper.removeAttribute('hidden');  
        errorMessage.textContent = response.message;
      } else {
        var productForm = submit.target.closest('product-form');
        var errorMessageWrapper = productForm.querySelector('.product-form__error-message-wrapper');
        errorMessageWrapper.setAttribute('hidden','');  
        PatternCart.renderContents(response);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      if (PatternCart && PatternCart.classList.contains('is-empty')) PatternCart.classList.remove('is-empty');
    });
  });
}
/*-----------------*/
if(document.querySelector('.product-kitstatic__submit')){
  document.querySelector('.product-kitstatic__submit').addEventListener('click', (submit) => {
    submit.stopPropagation();
    submit.preventDefault();

    var formSubmit = true;
    var form = submit.target.closest('form');
    var Quantity = form.querySelector('.qty_main_product').value;
    var properties = {};
    var mainProductData = new Array();

    document.querySelectorAll(".product_variant_colorway").forEach(function (inputWrapper) {
      var length = inputWrapper.querySelectorAll('input[type="checkbox"]:checked').length;
      var error_message = inputWrapper.querySelector('.product_variant_error');
      if(length === 0) {
        formSubmit = false;
        error_message.innerText = 'Please, select one option.';
        var scrollInput = inputWrapper.offsetTop;
        var scrollHeader = document.querySelector('sticky-header').offsetHeight;
        var scrollDiv = scrollInput - scrollHeader;
        window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
      }else{
        formSubmit = true;
        error_message.innerText = '';
      }
    });
  
    document.querySelectorAll('.product_variant_colorway-group .colorway-input:checked').forEach( (colorwayVariants) => {
      var variantTitle = colorwayVariants.dataset.titleValue;
      var variantId = colorwayVariants.value;
      var ColorProdList = colorwayVariants.nextElementSibling.querySelector('.product_variant_colorway_product_list');
      var properties = {};
      ColorProdList.querySelectorAll('.product_colorway_product_item').forEach((coldata, i) => {
        var count = i + 1;
        var DataProductId = coldata.getAttribute('data-product-id');
        var DataProduct = coldata.getAttribute('data-product');
        var DataQty = coldata.getAttribute('data-qty');
        var finalQty = DataQty * Quantity;
        properties["Colorway"] = variantTitle;
        mainProductData.push({
          id: DataProductId,
          quantity: finalQty,
          properties: properties
        });
      });
    });
   
    var selectedPattern = document.querySelector('.product_pattern input[name="product[pattern]"]:checked');
    var patternValue = selectedPattern ? selectedPattern.value : "";
    var patternQTY = selectedPattern ? selectedPattern.getAttribute('data-qty') : "";
    if(patternValue){
      mainProductData.push({
        id: patternValue,
        quantity: patternQTY
      });
    }
  
    if(formSubmit) {
      var PatternCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if(PatternCart){
        var formData = {
          'items': mainProductData,
          'sections': PatternCart.getSectionsToRender().map((section) => section.id),
          'sections_url': window.location.pathname
        }
        PatternCart.setActiveElement(document.activeElement);
      }
    
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(response => {
        if(response.message != "" && response.message != null) {
          var productForm = submit.target.closest('product-form');
          var errorMessageWrapper = productForm.querySelector('.product-form__error-message-wrapper');
          var errorMessage = errorMessageWrapper.querySelector('.product-form__error-message');
          errorMessageWrapper.removeAttribute('hidden');  
          errorMessage.textContent = response.message;
        } else {
          var productForm = submit.target.closest('product-form');
          var errorMessageWrapper = productForm.querySelector('.product-form__error-message-wrapper');
          errorMessageWrapper.setAttribute('hidden','');  
          PatternCart.renderContents(response);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        if (PatternCart && PatternCart.classList.contains('is-empty')) PatternCart.classList.remove('is-empty');
      });
    }
  });
}

// document.addEventListener("DOMContentLoaded", function(event) {
//   if(document.querySelector(".product_pattern-option")){
//     Totalamount();
//   }
//   if(document.querySelector(".product_pattern-static")){
//     Totalamountstatic();
//   }
//   if(document.querySelector('.product-swatches-shades-options')){
//     const listItems = document.querySelectorAll('.list_product_options , .options-list .product__title');
//     let minPrice = Infinity;
//     let minSprice = '';
//     let listItemsSize = listItems.length;
//     listItems.forEach(item => {
//       const price = parseFloat(item.getAttribute('data-price'));
//       const sprice = item.getAttribute('data-sprice');
      
//       if(price < minPrice){
//         minPrice = price;
//         minSprice = sprice;
//       }
//     });
//     if(listItemsSize > 1 && minSprice != '') { 
//       let Finaltext = "From " + minSprice;
//       if(document.querySelector('.product__info-container').querySelector('.price--product dl')) {
//         document.querySelector('.product__info-container').querySelector('.price--product dl').innerText = Finaltext;
//       }
//     }
//   }
// });

if (!customElements.get("back-to-top")) {
    class BackToTop extends HTMLElement {
        constructor() {
            super(),
            this.pageHeight = window.innerHeight
        }
        connectedCallback() {
            this.addEventListener("click", this.onClick),
            this.addEventListener("touchstart", this.onClick, {
                passive: !0
            }),
            window.addEventListener("scroll", this.checkVisible.bind(this))
        }
        checkVisible(event) {
            window.requestAnimationFrame(()=>{
                window.scrollY > this.pageHeight ? this.classList.add("back-to-top--active") : this.classList.remove("back-to-top--active")
            }
            )
        }
        onClick() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            })
        }
    }
    customElements.define("back-to-top", BackToTop)
}

if(document.querySelector('.product-swatches-shades .select-box')){
  document.querySelector('.product-swatches-shades .select-box').addEventListener('click', function() {
    document.querySelector('.product-swatches-shades .options-list').classList.toggle('show');
  });
}

// document.querySelectorAll('.product-swatches-shades .options-list li').forEach(function(option) {
//   option.addEventListener('click', function(event) {
    
//     const selectedText = this.querySelector('a').textContent;
//     // document.querySelector('.product-swatches-shades .selected-item').textContent = selectedText;
//     document.querySelector('.product-swatches-shades .options-list').classList.remove('show');
//   });
// });
  

// if(document.getElementById("product-card-shade-select-box-list")) {
//   let product_handle = document.getElementById("product-card-shade-select-box-list").dataset.productHandle;
//   let productHandles = document.getElementById("product-card-shade-select-box-list").dataset.productCardShade.split(', ');
//   let productData = [];
  
//   async function fetchProductByHandle(handle) {
//     let response = await fetch(`/products/${handle}.js`);
//     if (response.ok) {
//       return await response.json();
//     }
//     return null;
//   }
  
//   async function fetchAllProducts(handles) {
//     for (let handle of handles) {
//       let product = await fetchProductByHandle(handle);
//       if (product) {
//         productData.push(product);
//       } else {
//         console.error('Product not found for handle:', handle);
//       }
//     }
//     displayProducts(productData);
//   }
  
//   function displayProducts(products) {
//     document.getElementById("product-card-shade-select-box-list").innerHTML = "";
//     products.forEach((product) => {
//       let productHtml = `
//         <li class="product__title ${product_handle == product.handle ? `product_active_shade` : ''} ${product.available == false ? `product_sold` : ''}" data-price="${product.price}" data-sprice="${$money_format(product.price, $money_type)}">
//           <a href="${product.url}">${product.title}</a> 
//         </li>
//       `;
//       document.getElementById("product-card-shade-select-box-list").innerHTML += productHtml;
//     });
//   }
  
//   fetchAllProducts(productHandles);
// }
document.addEventListener("DOMContentLoaded", function(event) {
  if(document.querySelector('.product-swatches-shades-options')){
    var ulElement = document.querySelector('.product-swatches-shades-options ul');
    var eachLI = document.querySelectorAll('.list_product_options');
    
    function updateLastRowClass() {
      var parentTop = ulElement.getBoundingClientRect().top;
      var parentHeight = ulElement.clientHeight;
      var finalParent = parentTop + parentHeight;
      var posArray = [];
    
      // Remove 'tooltip-top' class from all list items before recalculating
      eachLI.forEach(function (li, i) {
        li.classList.remove("tooltip-top");
        var lipos = li.getBoundingClientRect().top;
        if (lipos < finalParent) {
          posArray.push(lipos);
        }
      });
    
      // Find the maximum value (the last row) and add the 'tooltip-top' class
      var maxValue = Math.max(...posArray);
      eachLI.forEach(function (li) {
        if (li.getBoundingClientRect().top === maxValue) {
          li.classList.add("tooltip-top");
        }
      });
    }
    // Initial check on page load
    updateLastRowClass();
    
    // Listen to the scroll event on the ul element
    document.querySelector('.product-swatches-shades-options ul').addEventListener('scroll', function () {
      updateLastRowClass();
    });
  }
});

if(document.querySelectorAll('.product_description_expanded')) {
  document.querySelectorAll('.product_description_expanded').forEach(function(element) {
    element.addEventListener('click', function() {
      var truncate = this.previousElementSibling;
      truncate.classList.toggle('product--description_truncate-hidden');
      this.textContent = this.textContent === "read more" ? "read less" : "read more";
    });
  });
}


if(document.querySelectorAll('.continue_button')) {
  document.querySelectorAll('.continue_button').forEach(function(element) {
    element.addEventListener("click", () => {
      history.back();
    });
  });
};